export default __webpack_public_path__ + "assets/icons/iconPartialSupport.2f18ebfc.svg";